/**
 * 글자 수 상한에 맞춰 **낱말 경계에서** 자른다 — 낱말 한가운데(「Sunscre」)에서 끊지 않는다.
 *
 * 🔑 잘랐을 때만 끝에 「…」를 붙인다 · 끝에 매달린 구두점(`,`·`-`·`|`·`(`)은 뗀다.
 * ⚠️ 상한 안에 빈칸이 하나도 없으면(띄어쓰기 없는 긴 낱말) 상한에서 그대로 자른다 — 그때도 이모지(서로게이트 짝)는 쪼개지 않는다(`sliceChars`).
 */

/**
 * @param max 「…」를 뺀 글자 수 상한
 * @returns 공백을 하나로 접은 글 — 상한 안이면 그대로
 */
export function clipAtWord(text: string, max: number): string {
  const flat = String(text ?? '').replace(/\s+/g, ' ').trim();
  if (flat.length <= max) return flat;
  const head = flat.slice(0, max + 1);
  const space = head.lastIndexOf(' ');
  const cut = space > 0 ? head.slice(0, space) : sliceChars(flat, max);
  return `${cut.replace(TRAILING_PUNCT_RE, '')}…`;
}

/**
 * 앞 `max` 칸(UTF-16)까지 — 끝이 이모지 같은 서로게이트 짝의 앞 반쪽이면 그 반쪽을 뺀다.
 * 🚨 반쪽을 남기면 서버가 그린 HTML(대체 문자 U+FFFD)과 브라우저의 글이 달라 하이드레이션이 깨진다.
 */
export function sliceChars(text: string, max: number): string {
  const head = String(text ?? '').slice(0, Math.max(0, max));
  const last = head.charCodeAt(head.length - 1);
  return last >= 0xd800 && last <= 0xdbff ? head.slice(0, -1) : head;
}

// ---- 이하 비공개 ----------------------------------------------------------

const TRAILING_PUNCT_RE = /[\s,·|/:;\-–—(([{]+$/;
